import { useTranslation } from "react-i18next";
import { LocalizedLink } from "@/i18n/language";
import { img } from "@/lib/images";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="story" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="eyebrow-brand text-sm md:text-base uppercase tracking-[0.35em] mb-3">
            — {t("home_about_eyebrow")} —
          </div>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.1] tracking-tight mb-6">
            {t("home_about_title")}
          </h2>
          <p className="text-foreground-700 leading-relaxed text-base md:text-lg whitespace-pre-line">
            {t("home_about_intro")}
          </p>

          <LocalizedLink
            to="/about"
            className="mt-8 inline-flex items-center gap-2 bg-background-50 border border-background-500 hover:border-primary-500 hover:bg-primary-600/20 text-foreground-950 px-7 py-3.5 rounded-md font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            {t("home_about_cta")}
            <i className="ri-arrow-right-line"></i>
          </LocalizedLink>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative rounded-lg overflow-hidden h-[420px] md:h-[640px]">
            <img
              src={img("home/home-kompiang-gery-01.jpg")}
              alt="Kompiang & Gery Nutz"
              title="Villa Kompiang – Ihre Gastgeber Kompiang & Gery"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}